/**
 * Patch HTMLDialogElement.showModal() to handle race conditions.
 *
 * Filament v3 and Livewire v3 both use native <dialog> elements for modals.
 * During rapid Livewire updates, a dialog can be opened with .show() (non-modal)
 * and then .showModal() is called before it's closed, causing an InvalidStateError.
 *
 * This patch ensures the dialog is closed before calling showModal().
 *
 * Browsers without <dialog> support (Safari before 15.4) have no HTMLDialogElement
 * global. Touching it unguarded at module top level threw a ReferenceError that
 * stopped app.js before Alpine and Livewire started (camps#8160), so it is skipped.
 *
 * @returns {boolean} whether the patch was applied
 */
export function patchDialogShowModal(scope = globalThis) {
    if (typeof scope.HTMLDialogElement !== 'function') {
        return false;
    }

    const originalShowModal = scope.HTMLDialogElement.prototype.showModal;
    scope.HTMLDialogElement.prototype.showModal = function () {
        if (this.open) {
            this.close();
        }
        return originalShowModal.call(this);
    };

    return true;
}
